import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SignInPrompt.css';

// Shown when a signed-out visitor tries something that needs an account (liking, replying,
// voting, commenting). Fixed to the bottom of the screen so it is seen wherever they clicked,
// and signing in returns them to the same page.
export default function SignInPrompt({ intent, onClose }) {
  const location = useLocation();
  if (!intent) return null;
  return (
    <div className="sl-signin-prompt" role="status">
      <span>Sign in to {intent}. It’s free.</span>
      <Link to="/login" state={{ from: location }} className="sl-btn sl-btn-primary">Sign in</Link>
      <Link to="/signup" className="sl-arrow-link">Create a free account</Link>
      <button type="button" className="sl-signin-close" onClick={onClose} aria-label="Close">✕</button>
    </div>
  );
}
